// @todo (CHAIR-18433) revisit when beginning test

import $ from 'jquery';

import { ExperimentKey, isExperimentVariantB } from 'chairisher/thirdparty/experiments';

/**
 * Toggles between displaying the favorite button (control) and the save button (treatment)
 * Note: The tooltip is only shown for the save button when the product is not favorited.
 *
 * @param {jQuery} $container The element containing the buttons
 * @param {boolean=} isValidScreenSize Whether the screen size is valid for displaying the save button (default: true)
 */
export function toggleSaveButtonDisplay($container, isValidScreenSize = true) {
    const $saveButtons = $container.find('.js-save-button');
    if (isExperimentVariantB(ExperimentKey.FAVORITE_ACTION_COPY_TEST) && isValidScreenSize) {
        $container.find('.js-favorite-only-button').remove();
        $container.find('.js-quick-buttons').addClass('is-save-button-displayed');

        $saveButtons.tooltip({ placement: 'top', title: 'Save to Favorites', trigger: 'manual' });
        $saveButtons.on('mouseenter', (e) => {
            const $button = $(e.currentTarget);
            if (!$button.hasClass('on')) {
                $button.tooltip('show');
            }
        });
        $saveButtons.on('mouseleave', (e) => $(e.currentTarget).tooltip('hide'));

        $saveButtons.removeClass('hidden');
    } else {
        $saveButtons.remove();
    }
}

/**
 * Toggles the save button text based on the favorite status of the product
 *
 * @param {jQuery} $button The button to toggle the text for
 * @param {boolean} isFavorite Whether the product is favorited or not
 */
export function toggleSaveButtonText($button, isFavorite) {
    if (isExperimentVariantB(ExperimentKey.FAVORITE_ACTION_COPY_TEST)) {
        $button.find('.js-save-button-text').text(isFavorite ? 'saved' : 'save');
    }
}
